
import { request, OPERATION_ID, init, cookies, cookiesSettings } from "./request";
import Stream from "../frp/stream";
import { UrlParamsToObject, get_prop } from "utils"

export const SERVER_STAGE_TYPE = {
    UNDEFINED : 0,
    REGULAR : 1,
    FINAL : 2,
    FREEGAME : 3, FREESPIN : 3,
    BONUS_1 : 4,
    BONUS_2 : 5,
    BONUS_3 : 6,
    /** Состояние окончания фригеймов или бонуса, где отображаются барабаны и игрок должен, обычно, решить что ему делать дальше: войти в риск или забрать выигрыш.*/
    FINISH : 7,
    JACKPOT : 8,
    /** Отображается как рулетка. Становится известно что будет дальше в сценарии: джекпот (следующим stage'ом) или бонус (когда-то потом в сценарии). После первого такого состояния следует второе такое же, где уже отображается выигрыш (в первом его нет в данных).*/
    PRECURSOR : 9,
    RISK_MAIN : 10,
    RISK_RESULT : 11,
    RISK_RESULT_RED : 12,
    RISK_RESULT_BLACK : 13,
    /** Не является состоянием которое может вернуть сервер, но на него можно перейти чтобы "попросить" сервер сохранить половину выигрыша в риске чтобы рисковать только оставшейся половиной (возможность сохранения половины определяется обычным образом: по наличию stage'а в waymap'е).*/
    RISK_WIN_SAVE : 14,
    PROGRESSIVE_JACKPOT : 30,
};
export const TYPE = SERVER_STAGE_TYPE;

export const SERVER_IDENTITY_TYPE = {
    /** { "terminal_id": -1265348240 } */
    TERMINAL : 1,
    /** { "terminal_id": -1265348240, "card_id": "01ad54fe" } */
    RFID : 2,
    /** { "login": "user1" } */
    WEB : 3
};

/**
* Возможные действия выбора игрока в риске. Позже рассмотрим архитектуру 4(5)-карточного риска.
* @type {{RED: number, BLACK: number}}
* @memberOf Server
*/
export const RISK_CHOICE =
{
    UNDEFINED : 0,
    RED : 1,
    BLACK : 2
};

/** Возможные типы рисков.*/
export const RISK_TYPE =
{
    UNDEFINED : 0,
    RED_BLACK : 1,
    FIVE_CARDS : 2,
    RED_BLACK_SRS : 3,
    LEFT_RIGHT : 5,
};

export const RISK_WIN_MULT = 2

//оказывается не раотает если определять только как this - чтобы работало как и раньше через Server.GAME_TYPE:
/** Enum for possible game types server may station on. */
export const GAME_TYPE = {
    UNDEFINED_GAME_TYPE : 0,

    /** Основная игра (вращающийся барабан). Отсюда переходить в: риск, фригеймы, взять выигрыш или просто "объявить" об окончании спина (takeWin()). */
    REGULAR : 1,

    /** Фриспин. Дальше либо: фриспин, takeWin(), risk. */
    FREEGAME : 2,

    /** Процесс выбора карты в риске.*/
    RISK : 3,

    /** Какой-то обычный бонус.*/
    BONUS_1 : 5,
    /** Какой-то ещё бонус.*/
    BONUS_2 : 6,
    /** Супер-бонус, наверно.*/
    BONUS_3 : 7,

    /** Просто денежный выигрыш независящий ни от чего - доступен после состояния REGULAR.*/
    JACKPOT : 8,

    /** Отображается как рулетка. Становится известно что будет дальше в сценарии: джекпот (следующим stage'ом) или бонус (когда-то потом в сценарии).*/
    PRECURSOR : 9,
    /** Рулетка только что показалась. Нужно нажать на старт чтобы перейти на следующее такое же состояние, но где будет уже известно что за выигрыш.*/
    PRECURSOR_STARTING : 9001,

    /** When player just observes any previous states result. There are winnings,
        * bets, combinations, etc, but player already played it at previous login,
        * so just skip this state with spin() call. */
    FINAL : 10,

    /** Состояние окончания фригеймов или бонуса, где отображаются барабаны и игрок должен, обычно, решить что ему делать дальше: войти в риск или забрать выигрыш.*/
    FINISH : 11
};

/** Game state manipulation utility [non-imperative] functions.*/
export default class ServerTool
{
    //чтобы работало через this accessor:
    get GAME_TYPE() { return GAME_TYPE; }
    
    /** Returns game type name
    @param {Number} gameType game type identifier
    @return {String} game type symbolic name
    */
    gameTypeName( gameType )
    {
        for (var name in this.GAME_TYPE) {
            if (this.GAME_TYPE[name] === gameType) {
                return name;
            }
        }

        //эта функция используется для отладки и, обычно, когда gameType() УЖЕ провалилась (не соответствует ожиданиям и т.д.) и, скорее всего, провалилась в try/catch, поэтому здесь выбрасывание exception'а не только необязательно, но и противоречиво:
        return "UNKNOWN GAME TYPE";
    };

    stageTypeName( stageType )
    {
        for ( var name in SERVER_STAGE_TYPE )
        {
            if ( SERVER_STAGE_TYPE[ name ] == stageType )
            {
                return name;
            }
        }
    };

    /** Getter. Returns true if specified bonus is available and can be used to enter it with proceedBonus().
    @param bonusType One of Server.GAME_TYPE.BONUS_... constants.
    */
    isBonusAvailable(
        bonusType
    )
    {
        var server = this;
        //looking for specified bonus:
        var bonus = this.lastState.way_map.find( function ( nextStage )
        {
            switch ( bonusType )
            {
                case server.GAME_TYPE.BONUS_1:
                    return nextStage == SERVER_STAGE_TYPE.BONUS_1;
                case server.GAME_TYPE.BONUS_2:
                    return nextStage == SERVER_STAGE_TYPE.BONUS_2;
                case server.GAME_TYPE.BONUS_3:
                    return nextStage == SERVER_STAGE_TYPE.BONUS_3;
            }
            return false;
        } );
        if ( bonus != undefined )
        {
            return true;
        }
    };

    isJackpotAvailable()
    {
        return this.lastState.way_map.find( function( nextStage )
        {
            return nextStage == SERVER_STAGE_TYPE.JACKPOT
        } ) != undefined
    }

    get RISK_CHOICE() { return RISK_CHOICE; }

    get math() { return this.lastState.stage.math || {} }

    /**
        * Get slot symbols.
        * @returns {Number[]} last spin slot symbols. Rows first.
        * @memberOf Server
        */
    get symbols()
    {
        if (this.lastState.stage.math) {
            return this.lastState.stage.math.symbols;
        }
        return null;
    }

    /**
        * @returns Текущее количество кредитов по версии сервера. Изменяется после начала сценария (вычет ставки), получения выигрыша (takeWin()).
        * @memberOf Server
        */
    get credits()
    {
        return resolveCredits( this.balance );
    }

    /**
        * @returns Последовательный номер (НЕ индекс: первый фриспин имеет номер "1") текущего фриспина в рамках фригеймов. Если фригеймы были только что выиграны (сейчас основная игра), то 0.
        * @memberOf Server
        */
    get freespinNumber()
    {
        if ( this.lastState.stage.math.currentFreeGameNumber )
        {
            return parseInt( this.lastState.stage.math.currentFreeGameNumber );
        }
        return 0;
    }

    /**
        * @returns Сколько ещё выиграно фриспинов в рамках текущего фриспина.
        * @memberOf Server
        */
    get freespinsIncrease()
    {
        if ( this.lastState.stage.math.freeGamesCountIncrease )
        {
            return parseInt( this.lastState.stage.math.freeGamesCountIncrease );
        }
        return 0;
    }

    /**
        * @returns Сколько всего фриспинов в текущем фригейме, включая все дополнительные, или сколько будет (не считая возможные будущие дополнительные) если фриспины были только что выиграны в основной (обычной) игре. Например, в основной игре выпало 7 фриспинов, то число будет 7; затев во фриспинах выпадает ещё 5 и, в дальнейшем, будет 12. Если в текущем фриспине были выиграны ещё фриспины, то также прибавляет и их.
        * @memberOf Server
        */
    get freespinsCount()
    {
        if ( this.lastState.stage.math.freeGamesCount )
        {
            return parseInt( this.lastState.stage.math.freeGamesCount ) + this.freespinsIncrease;
        }
        return parseInt( this.lastState.stage.math.freeGamesCountIncrease );
    }

    //TODO: implement fractional arythmetics:
    /**
        * @returns Amount of winnings within current spin (or freespin if it's freespin currently).
        * @memberOf Server
        */
    get spinWinInCoins()
    {
        return parseInt( this.lastState.stage.win ) * parseInt( this.lastState.multiplier );
    }

    //TODO: implement fractional arithmetic:
    /**
        * @returns Gross amount of winnings (sum of all spinWin() for every spin/freespin) within current scenario.
        * @memberOf Server
        */
    get totalWinInCoins()
    {
        return stateWinInCoins( this.lastState );
    }

    /**
        * @returns true если следующая стадия - это freespin и нужно будет вызвать Server.freespin().
        * @memberOf Server
        */
    get isFreespinAvailable()
    {
        if ( this.lastState.stage.type_id != SERVER_STAGE_TYPE.FINAL )
        {
            //looking for freegame:
            if ( $.inArray( SERVER_STAGE_TYPE.FREEGAME, this.lastState.way_map ) >= 0 )
            {
                return true;
            }
        }
        return false;
    }

    /**
        * Utility function to check if player may choose enter risk or take winning avoiding it.
        * @memberOf Server
        */
    get isRiskAvailable()
    {
        //в математике сервера есть баг где по логике течения сценария риск доступен, однако в игре его вообще нету, но такая проверка на сервере повышает нагрузку - перекинули её на клиент:
        if ( ! this.loginData.spec.risks || this.loginData.spec.risks.length < 1 )
        {
            return false;
        }

        return this.lastState.risk_possible
    }
    /**
        * @returns {Number} Масть текущей карты в риске (очевидно, доступно только после выбора между "чёрным" и "красным"). Индекс в массиве спецификации, например в "Hearts" | "Diamonds" | "Spades" | "Clubs".
        * @see riskSuitName
        * @memberOf Server
        */
    get riskSuit()
    {
        if ( this.riskState && this.riskState.stage && this.riskState.stage.math )
        {
            return this.riskState.stage.math.suit;
        }
        //это нормально:
        //console.error( 'Server.get riskSuit(): seems like not even a risk state.' );
        return undefined;
    }
    /**
    @returns {Number} от 0 до 12, где 0 - это "двойка", 12 - это "туз".
    */
    get riskNominal()
    {
        if ( this.riskState && this.riskState.stage && this.riskState.stage.math )
        {
            return this.riskState.stage.math.nominal;
        }
        //это нормально:
        //console.error( 'Server.get riskNominal(): seems like not even a risk state.' );
        return undefined;
    }
    /**
    @returns {[String]} Массив возможных мастей карт в риске.
    */
    get riskSuitNames()
    {
        return this.loginData.spec.risks[ 0 ].specification.suitNames;
    }
    /**
    @returns {String} Имя текущей карты в риске. Одно из "hearts" | "diamonds" | "spades" | "clubs".
    */
    get riskSuitName()
    {
        return this.riskSuitNames[ this.riskSuit ];
    }
    /**
    @returns {Number} Мультипликатор текущего выигрыша в риске. Как я понимаю, либо 0, либо 2.
    */
    get riskWinMultiplier()
    {
        return this.riskState.stage.win_multiplier;
    }
    /**
    @returns {Number} Какая карта была выбрана игроком. Константа из Server.RISK_CHOICE.
    @memberOf Server
    */
    get riskChoice()
    {
        return resolveRiskChoice( this, this.riskState );
    }
    /**
    @returns {Number} Сколько уже выиграно в риске.
    */
    get riskCurrentWin()
    {
        //сразу при входе в риск для отображения требуется узнать текущий выигрышь, хотя ещё ни одного финала риска не было, поэтому в таком случае нужно брать из основного спина:
        if ( this.riskState )
        {
            return stateWinInCoins( this.riskState )
        }
        //иногда требуется унать выигрышь в риске когда игра уже в состоянии FINAL:
        return stateWinInCoins( this.lastState )
    }
    /**
    @returns {Number} Каким будет выигрыш игрока если он выиграет в текущем риске.
    */
    get riskFutureWin()
    {
        return this.riskCurrentWin * RISK_WIN_MULT;
    }
    /**
    @returns {[ { nominal : Number, suit : Number } ]} Последние 10 игр в риске.
    */
    get riskHistory()
    {
        return this.riskHistoryData || [];
    }
    /** Возвращает карту дилера если сейчас пятикарточный риск и игрок должен выбрать свою карту из четырёх предоставленных.*/
    get dealerCard()
    {
        return resolveDealerCard( this.lastState );
    }
    /** Шаг риска внутри сценария. Т.е. победа или ничья в риске увеличивают число в рамках сценария на 1. 0 - ни разу ещё не играли (может быть риск уже сейчас или сразу забрали выигрыш и сейчас игрок находится в FINAL (видит барабаны).*/
    get riskIteration()
    {
        return this.lastState.risk_iteration;
    }

    /**
    @returns type of the current game.
    */
    get gameType()
    {
        return resolveGameType( this, this.lastState );
    }
    get type()
    {
        return this.lastState.stage.type_id
    }

    /**
    @returns True если текущее состояние (Server.lastState) - это просто статическое (без показа выигрышных лини, анимаций, ...) отображение предыдущей стадии. Результат нажатия кнопки "COLLECT" (также известной как "take win").
    */
    get isFinal()
    {
        return this.gameType == this.GAME_TYPE.FINAL;
    }

    get riskState()
    {
        return this._riskState;
    }
    set riskState( to )
    {
        this._riskState = to;
        //чтобы однозначно ограничить переплетение логики соседних рисков:
        delete this.riskResult;
    }

    /** Last spin bet values. Lines would be for example [1,3,5,7,9].*/
    get betValue()
    {
        return {
            lines : this.lastState.line_count,
            multiplier : this.lastState.multiplier,
        };
    }
    betToValue( bet )
    {
        //<= 0 не бывает, но при смене настроек ставок на сервере, на клиенте индекс может стать невозможным (массив может поменять размерность) и текстовые метки станут пустыми:
        const li = bet.lines < 0 ? 0 : Math.min( bet.lines, this.loginData.spec.lines_array.length - 1 )
        const mi = bet.multiplier < 0 ? 0 : Math.min( bet.multiplier, this.loginData.spec.bets_array.length - 1 )
        return {
            lines : this.loginData.spec.lines_array[ li ],
            multiplier : this.loginData.spec.bets_array[ mi ],
        };
    }
    /** Last spin bet indices. Lines would be for example [0,1,2,3,4].*/
    get bet()
    {
        //при нахождении внутри одного и того же сценария на сервере может поменяться массив возможных ставок, что может не только к несоответствую текущей ставки с реальным элементом в массиве, но и вообще к выходу из за пределы массива:
        const li = this.loginData.spec.lines_array.indexOf( this.betValue.lines )
        if ( li < 0 ) console.error( "Current server-side line bet value", this.betValue.lines, "was NOT resolved within", this.loginData.spec.lines_array )
        const mi = this.loginData.spec.bets_array.indexOf( this.betValue.multiplier )
        if ( mi < 0 ) console.error( "Current server-side multiplier bet value", this.betValue.multiplier, "was NOT resolved within", this.loginData.spec.bets_array )
        return {
            lines : Math.max( li, 0 ),
            multiplier : Math.max( mi, 0 ),
        };
    }
    /** @param bet indices */
    price( bet )
    {
        bet = bet || this.bet;
        return this.loginData.spec.lines_array[ bet.lines ] * this.loginData.spec.bets_array[ bet.multiplier ];
    }
    cannotPay( bet )
    {
        return this.price( bet ) > this.credits;
    }
    /** Transforms specified bet in such a way that it can be paid.*/
    shrink( bet )
    {
        const r = Object.assign( {}, bet );
        //first try to get as high amount of lines as possible:
        r.multiplier = 0;
        r.lines = Math.min( bet.lines, this.loginData.spec.lines_array.length - 1 )
        while ( this.cannotPay( r ) )
        {
            if ( r.lines > 0 )
            {
                -- r.lines;
                continue;
            }
            break;
        }
        //then shrink multiplier starting from the specified amount:
        r.multiplier = Math.min( bet.multiplier, this.loginData.spec.bets_array.length - 1 )
        while ( this.cannotPay( r ) )
        {
            if ( r.multiplier > 0 )
            {
                -- r.multiplier;
                continue;
            }
            break;
        }
        return r;
    }

    get restore()
    {
        return this.stateOrder == 1;
    }
}

export function resolveRiskChoice( server, state )
{
    if ( state )
    {
        switch ( state.stage.type_id )
        {
            case SERVER_STAGE_TYPE.RISK_RESULT_RED:
                return server.RISK_CHOICE.RED;
            case SERVER_STAGE_TYPE.RISK_RESULT_BLACK:
                return server.RISK_CHOICE.BLACK;
        }
    }
    return SERVER_STAGE_TYPE.UNDEFINED;
}

export function resolveGameType( server, state )
{
    //TODO: other types not implemented on server yet so we don't know how to determine between them ...
    switch ( parseInt( state.stage.type_id ) )
    {
        case SERVER_STAGE_TYPE.REGULAR:
            return server.GAME_TYPE.REGULAR;

        case SERVER_STAGE_TYPE.FINAL:
            return server.GAME_TYPE.FINAL;

        case SERVER_STAGE_TYPE.FREEGAME:
            return server.GAME_TYPE.FREEGAME;

        case SERVER_STAGE_TYPE.BONUS_1:
            return server.GAME_TYPE.BONUS_1;

        case SERVER_STAGE_TYPE.BONUS_2:
            return server.GAME_TYPE.BONUS_2;

        case SERVER_STAGE_TYPE.BONUS_3:
            return server.GAME_TYPE.BONUS_3;

        case SERVER_STAGE_TYPE.FINISH:
            return server.GAME_TYPE.FINISH;

        case SERVER_STAGE_TYPE.JACKPOT:
            return server.GAME_TYPE.JACKPOT;

        case SERVER_STAGE_TYPE.PRECURSOR:
            if ( state.way_map.find( function( avail ) { return avail == SERVER_STAGE_TYPE.PRECURSOR; } ) )
            {
                return server.GAME_TYPE.PRECURSOR_STARTING;
            }
            return server.GAME_TYPE.PRECURSOR;

        case SERVER_STAGE_TYPE.RISK_MAIN:
            return server.GAME_TYPE.RISK;
    }

    //people get annoyed by this message, but it's OK (it's legacy code anyway, so any newly-introduced stages will be processed specifically):
    //console.error( 'Server.resolveGameType: gameType =', state.stage.type_id, 'is undefined.' )

    return server.GAME_TYPE.UNDEFINED_GAME_TYPE;
}

export function isRiskResult( state )
{
    if ( state && state.stage ) return is_risk_result_type( state.stage.type_id )

    return false;
}

export function is_risk_result_type( type )
{
    switch ( type )
    {
        case SERVER_STAGE_TYPE.RISK_RESULT_RED:
        case SERVER_STAGE_TYPE.RISK_RESULT_BLACK:
        case SERVER_STAGE_TYPE.RISK_RESULT:
            return true;
    }
    return false
}

/** Returns true if state type is anything about risk.*/
export function is_risk_type( type )
{
    return is_risk_result_type( type ) || type == TYPE.RISK_MAIN
}

export function resolveCredits( balance )
{
    return parseInt( balance.gameable );
}

/** Берёт из указанного состояния ответа сервера карту дилера, если есть.
    * @return { rank : Int, suit : Int } */
export function resolveDealerCard( state )
{
    //using if() instead of try/catch to avoid debugger stops:
    if ( state && state.stage && state.stage.math )
    {
        return state.stage.math.dealerCard;
    }

    return undefined;
}

/** Возвращает обработанное состояние риска для более удобного использования в игре.*/
export function processRisk(
    server,
    riskState
)
{
    if ( ! riskState ) return;
    const choice = server.scenarioData ? server.scenarioData.choice : undefined;

    var processed = {
        dealer : resolveDealerCard( riskState ),
        cards : [],
        choice,
        //true если ничья:
        forward : riskState.stage.win_multiplier == 1
    };

    var playerCards = riskState.stage.math.playerCards;
    if ( playerCards )
    {
        for ( var i in playerCards.rank )
        {
            if ( playerCards.rank.hasOwnProperty( i ) !== true )
            {
                continue;
            }

            processed.cards.push(
                {
                    rank : playerCards.rank[ i ],
                    suit : playerCards.suit[ i ]
                }
            );
        }
    }

    if ( choice !== undefined )
    {
        const swapChoice = choice - 1;
        var swap = processed.cards[ swapChoice ];
        processed.cards[ swapChoice ] = processed.cards[ 0 ];
        processed.cards[ 0 ] = swap;
    }

    return processed;
}

/** Choose specified available state if such is actually available or result to FINAL one.*/
export function availableOrFinal(
    available,
    state
)
{
    var isAvailable = state.way_map.find( function( availableChoice )
    {
        return available == availableChoice;
    } );
    if ( isAvailable === undefined )
    {
        return SERVER_STAGE_TYPE.FINAL;
    }
    return available;
}

export function canGo( stage, state )
{
    if ( state.state ) state = state.state;
    return state.way_map.find( availableChoice => stage == availableChoice ) !== undefined;
}

export function canOnlyGo( stage, state )
{
    if ( state.state ) state = state.state;
    return state.way_map.length == 1 && state.way_map[ 0 ] == stage;
}

export function cannotGo( stage, state )
{
    if ( state.state ) state = state.state;
    return ! _.includes( state.way_map, stage );
}

export function stateWinInCoins(
    state
)
{
    return parseInt( state.open_win )
}

export function can_save_risk_win( state )
{
    return canGo( TYPE.RISK_WIN_SAVE, state )
}






// WEBPACK FOOTER //
// ./src/library/network/server_tool.es6